import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import { CartUpdatePost, getCartItems, updateCart } from "../services/CartService";

export default class CartStore {
  cart: any[] = [];

  constructor() {
    makeAutoObservable(this);
  }


  loadCartItems = async (outlet_id: number) => {
    try {
      const res = (await getCartItems(outlet_id)) as {
        status: string;
        data: any[];
        message: string;
      };
      if (res && res.status === "success") {
        runInAction(() => {
          this.cart = res.data;
        });
      }
    } catch (error) {
      toast.error("Could not load cart items");
    }
  };

  updateCartQuantity = async (
   req:CartUpdatePost,
   outlet_id:number
  ) => {
    try {
      const updatedCartItem = (await updateCart(req)) as {
        status: string;
      };

      if (updatedCartItem.status === "success") {
        this.loadCartItems(outlet_id);
      }
    } catch (error) {
      toast.error("Failed to update cart quantity");
    }
  };
  get totalItems() {
    return this.cart.length;
  }

  get totalAmount() {
  return this.cart.reduce((total, item) => {
    const customPrice = item.custom_price ? parseFloat(item.custom_price) : null;
    const price = customPrice && customPrice > 0
      ? customPrice
      : parseFloat(item.product?.base_price ?? "0");
    const qty = item.quantity ?? 1;
    return total + price * qty;
  }, 0);
}
}
